export const provs = [{
  id: "0111001",
  name: "Alcalá de los Gazules"
}, {
  id: "0111002",
  name: "Alcalá del Valle"
}, {
  id: "0111003",
  name: "Algar"
}, {
  id: "0111004",
  name: "Algeciras",
  important: true
}, {
  id: "0111005",
  name: "Algodonales"
}, {
  id: "0111006",
  name: "Arcos de la Frontera",
  important: true
}, {
  id: "0111007",
  name: "Barbate"
}, {
  id: "0111008",
  name: "Los Barrios"
}, {
  id: "0111009",
  name: "Benaocaz"
}, {
  id: "0111010",
  name: "Bornos"
}, {
  id: "0111011",
  name: "El Bosque"
}, {
  id: "0111012",
  name: "Cádiz",
  important: true,
  showInList: true,
  capital: true
}, {
  id: "0111013",
  name: "Castellar de la Frontera"
}, {
  id: "0111014",
  name: "Conil de la Frontera"
}, {
  id: "0111015",
  name: "Chiclana de la Frontera",
  important: true
}, {
  id: "0111016",
  name: "Chipiona"
}, {
  id: "0111017",
  name: "Espera"
}, {
  id: "0111018",
  name: "El Gastor"
}, {
  id: "0111019",
  name: "Grazalema"
}, {
  id: "0111020",
  name: "Jerez de la Frontera",
  important: true,
  showInList: true
}, {
  id: "0111021",
  name: "Jimena de la Frontera"
}, {
  id: "0111022",
  name: "La Línea de la Concepción",
  important: true
}, {
  id: "0111023",
  name: "Medina-Sidonia"
}, {
  id: "0111024",
  name: "Olvera"
}, {
  id: "0111025",
  name: "Paterna de Rivera"
}, {
  id: "0111026",
  name: "Prado del Rey"
}, {
  id: "0111028",
  name: "Puerto Real",
  important: true
}, {
  id: "0111027",
  name: "El Puerto de Santa María",
  important: true
}, {
  id: "0111029",
  name: "Puerto Serrano"
}, {
  id: "0111030",
  name: "Rota"
}, {
  id: "0111031",
  name: "San Fernando",
  important: true
}, {
  id: "0111032",
  name: "Sanlúcar de Barrameda",
  important: true
}, {
  id: "0111033",
  name: "San Roque"
}, {
  id: "0111034",
  name: "Setenil de las Bodegas"
}, {
  id: "0111035",
  name: "Tarifa"
}, {
  id: "0111036",
  name: "Torre Alháquime"
}, {
  id: "0111037",
  name: "Trebujena"
}, {
  id: "0111038",
  name: "Ubrique"
}, {
  id: "0111039",
  name: "Vejer de la Frontera"
}, {
  id: "0111040",
  name: "Villaluenga del Rosario"
}, {
  id: "0111041",
  name: "Villamartín"
}, {
  id: "0111042",
  name: "Zahara"
}, {
  id: "0111901",
  name: "Benalup-Casas Viejas"
}, {
  id: "0111902",
  name: "San José del Valle"
}];
export const provCapitals = [{
  "ineid": "14021",
  "parent": "14",
  "name": "Córdoba"
}, {
  "ineid": "29067",
  "parent": "29",
  "name": "Málaga"
}, {
  "ineid": "41091",
  "parent": "41",
  "name": "Sevilla"
}, {
  "ineid": "52001",
  "parent": "52",
  "name": "Melilla"
}, {
  "ineid": "22125",
  "parent": "22",
  "name": "Huesca"
}, {
  "ineid": "44216",
  "parent": "44",
  "name": "Teruel"
}, {
  "ineid": "05019",
  "parent": "05",
  "name": "Ávila"
}, {
  "ineid": "24089",
  "parent": "24",
  "name": "León"
}, {
  "ineid": "40194",
  "parent": "40",
  "name": "Segovia"
}, {
  "ineid": "25120",
  "parent": "25",
  "name": "Lleida"
}, {
  "ineid": "01059",
  "parent": "01",
  "name": "Vitoria-Gasteiz"
}, {
  "ineid": "48020",
  "parent": "48",
  "name": "Bilbao"
}, {
  "ineid": "26089",
  "parent": "26",
  "name": "Logroño"
}, {
  "ineid": "19130",
  "parent": "19",
  "name": "Guadalajara"
}, {
  "ineid": "04013",
  "parent": "04",
  "name": "Almería"
}, {
  "ineid": "21041",
  "parent": "21",
  "name": "Huelva"
}, {
  "ineid": "30030",
  "parent": "30",
  "name": "Murcia"
}, {
  "ineid": "06015",
  "parent": "06",
  "name": "Badajoz"
}, {
  "ineid": "10037",
  "parent": "10",
  "name": "Cáceres"
}, {
  "ineid": "09059",
  "parent": "09",
  "name": "Burgos"
}, {
  "ineid": "42173",
  "parent": "42",
  "name": "Soria"
}, {
  "ineid": "32054",
  "parent": "32",
  "name": "Ourense"
}, {
  "ineid": "12040",
  "parent": "12",
  "name": "Castellón de la Plana"
}, {
  "ineid": "34120",
  "parent": "34",
  "name": "Palencia"
}, {
  "ineid": "33024",
  "parent": "33",
  "name": "Gijón"
}, {
  "ineid": "51001",
  "parent": "51",
  "name": "Ceuta"
}, {
  "ineid": "35016",
  "parent": "35",
  "name": "Las Palmas de Gran Canaria"
}, {
  "ineid": "38038",
  "parent": "38",
  "name": "Santa Cruz de Tenerife"
}, {
  "ineid": "08019",
  "parent": "08",
  "name": "Barcelona"
}, {
  "ineid": "43148",
  "parent": "43",
  "name": "Tarragona"
}, {
  "ineid": "15030",
  "parent": "15",
  "name": "La Coruña"
}, {
  "ineid": "27028",
  "parent": "27",
  "name": "Lugo"
}, {
  "ineid": "36038",
  "parent": "36",
  "name": "Pontevedra"
}, {
  "ineid": "20069",
  "parent": "20",
  "name": "Donostia/San Sebastián"
}, {
  "ineid": "07040",
  "parent": "07",
  "name": "Palma"
}, {
  "ineid": "03014",
  "parent": "03",
  "name": "Alicante/Alacant"
}, {
  "ineid": "18087",
  "parent": "18",
  "name": "Granada"
}, {
  "ineid": "28079",
  "parent": "28",
  "name": "Madrid"
}, {
  "ineid": "02003",
  "parent": "02",
  "name": "Albacete"
}, {
  "ineid": "13034",
  "parent": "13",
  "name": "Ciudad Real"
}, {
  "ineid": "16078",
  "parent": "16",
  "name": "Cuenca"
}, {
  "ineid": "39075",
  "parent": "39",
  "name": "Santander"
}, {
  "ineid": "49275",
  "parent": "49",
  "name": "Zamora"
}, {
  "ineid": "46250",
  "parent": "46",
  "name": "València"
}, {
  "ineid": "11012",
  "parent": "11",
  "name": "Cádiz"
}, {
  "ineid": "50297",
  "parent": "50",
  "name": "Zaragoza"
}, {
  "ineid": "45168",
  "parent": "45",
  "name": "Toledo"
}, {
  "ineid": "37274",
  "parent": "37",
  "name": "Salamanca"
}, {
  "ineid": "47186",
  "parent": "47",
  "name": "Valladolid"
}, {
  "ineid": "17079",
  "parent": "17",
  "name": "Girona"
}, {
  "ineid": "31201",
  "parent": "31",
  "name": "Pamplona/Iruña"
}, {
  "ineid": "23050",
  "parent": "23",
  "name": "Jaén"
}];